import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  //base: '/ecommerce-client',
  routes: [{
    path: '/',
    name: 'inicio',
    component: Home
  },
  {
    path: '/inicio',
    name: 'inicio',
    component: Home
  },
  {
    path: '/nosotros',
    name: 'nosotros',
    component: () => import('./views/About.vue')
  },
  {
    path: '/catalogos',
    name: 'catalogos',
    component: () => import('./views/Publications.vue')
  },
  {
    path: '/catalogos-ofertas',
    name: 'catalogos-ofertas',
    component: () => import('./views/PublicationsOffers.vue')
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: () => import('./views/Contact.vue')
  },
  {
    path: '/reclamo',
    name: 'reclamo',
    component: () => import('./views/Claims.vue')
  },
  {
    path: '/nuestras-tiendas',
    name: 'nuestras-tiendas',
    component: () => import('./views/OurShop.vue')
  },

  {
    path: '/comunidad/:idnews?',
    name: 'comunidad',
    component: () => import('./views/Comunity.vue')
  },
  
  {
    path: '/productos/:crit?/:page?/:cate?/:subcate?/:caliber?/:brand?/:query?',
    name: 'productos',
    component: () => import('./views/Products.vue')
  },
  /*
  {
    path: '/productos/busqueda/:query/:subcate',
    name: 'busqueda',
    component: () => import('./views/SearchProducts.vue')
  },
  */
  {
    path: '/producto/:id',
    name: 'detalle-productos',
    component: () => import('./components/products/ProductDetail.vue')
  },
  {
    path: '/carrito',
    name: 'carrito',
    component: () => import('./components/products/cart/CartProducts.vue'),
    beforeEnter: (to, from, next) => {
      next()
    }
  },
  {
    path: '/pago',
    name: 'pago',
    component: () => import('./components/checkout/CheckoutPayment.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/login.vue')
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: () => import('./views/Profile.vue')
  },
  {
    path: '/pedidos',
    name: 'pedidos',
    component: () => import('./views/Orders.vue')
  },
  {
    path: '/confirmacion',
    name: 'confirmacion',
    component: () => import('./views/Confirmation.vue')
  },
  {
    path: '/ofertas',
    name: 'ofertas',
    component: () => import('./views/Offers.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('./views/404.vue')
  },
  { 
    path: '*', 
    component: () => import('./views/404.vue') 
  }
  ]
})
